<template>
  <MainTab :main-title="mainTitle">
    <ContentWrapper>
      <template #header>
        <!-- eslint-disable-next-line vue/no-v-html-->
        <div class="dea-heading--medium__s" v-html="activeRegistration().linked_event.event_post_event_message"></div>
      </template>
      <template #default>
        <DownloadMaterial :registration="activeRegistration()"></DownloadMaterial>
      </template>
    </ContentWrapper>
  </MainTab>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import DownloadMaterial from "~/components/events/components/DownloadMaterial";
import MainTab from "~/components/events/components/MainTab";

export default {
  name: "EventsDownload",
  components: {
    MainTab,
    ContentWrapper,
    DownloadMaterial,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
  },
  computed: mapGetters(["activeRegistration"]),
  mounted() {
    this.fetchRegistration({ registrationId: this.$route.params.registration, force: false });
  },
  methods: mapActions(["fetchRegistration"]),
};
</script>
